import { useCallback, useEffect, useState } from 'react';
import {
  getInitialNotificationConfig,
  saveNotificationConfig,
} from '../utils/storage';
import {
  getNotificationTimings,
  saveNotificationTimings,
} from '../utils/api';

export const useNotificationConfig = () => {
  const [notificationConfig, setNotificationConfig] = useState(() => getInitialNotificationConfig());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const data = await getNotificationTimings();
        if (!mounted) return;
        const nextConfig = {
          notificationTimings: data?.notificationTimings || getInitialNotificationConfig().notificationTimings,
          notificationLevels: data?.notificationLevels || getInitialNotificationConfig().notificationLevels,
        };
        setNotificationConfig(nextConfig);
        saveNotificationConfig(nextConfig);
      } catch (e) {
        console.warn('Falling back to local notification config. Reason:', e?.message || e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => { mounted = false; };
  }, []);

  const handleSaveNotificationConfig = useCallback((newConfig) => {
    setNotificationConfig(newConfig);
    saveNotificationConfig(newConfig);
    saveNotificationTimings(newConfig.notificationTimings, newConfig.notificationLevels).catch((e) => {
      console.warn('Remote save for notification config failed, kept local:', e?.message || e);
    });
  }, []);

  return {
    notificationConfig,
    handleSaveNotificationConfig,
    loading,
  };
};
